export default [
  {
    name: 'esqueci-senha-interno',
    path: '/esqueci-senha-interno',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/app-modulo/documento/esqueci-senha-interno/EsqueciSenhaInterno.vue'),
    meta: {
      requiredAuth: false,
      layout: 'full',
    },
  },
]
